import { makeAutoObservable } from 'mobx';
import axios from 'axios';

import User from './models/User';

export default class UserStore {
    constructor() {
        makeAutoObservable(this);
    }

    async find() {
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/users?size=1000`);
        return data.users.map((user: any) => new User().fromJSON(user)) as User[];
    }

    async findById(id: string) {
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/users/${id}`);
        return new User().fromJSON(data);
    }

    static async findById(id: string) {
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/users/${id}`);
        return new User().fromJSON(data);
    }

    static async saveById(id: string, formData: any) {
        const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/users/${id}`, formData);
        return new User().fromJSON(data);
    }

    static async deleteById(id: string) {
        await axios.delete(`${process.env.REACT_APP_API_URL}/users/${id}`);
    }
}
